/**
 * Minimal HTML escaper. Used in two places today:
 *   1. `lib/email.ts` — building the HTML body of contact-form emails.
 *   2. `components/heroes/terminal/terminal-prompt.ts` — building the
 *      colored prompt HTML that gets dropped into the prompt span
 *      via `innerHTML`.
 *
 * Centralised so both call sites agree on what characters need
 * escaping. Server- and client-safe: pure string manipulation,
 * no dependencies.
 */
export function escapeHtml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
